import { type LoaderFunctionArgs } from 'react-router';
import {
  getAppPageFromPath,
  getOperationFromPath,
} from '../../helpers/urlHelper';
import { isOperationPage, type AppPage } from '../../types/app';

export interface PageWrapperLoaderData {
  page: AppPage;
  operation?: string;
}

const loader = async (
  args: LoaderFunctionArgs,
): Promise<PageWrapperLoaderData> => {
  const { request } = args;
  const url = new URL(request.url);
  const page = getAppPageFromPath(url.pathname);
  const pathSegments = url.pathname.split('/').filter(Boolean);
  if (isOperationPage(page) && !pathSegments.includes('followup')) {
    const operation = getOperationFromPath(page, url.pathname);
    return { page, operation };
  }
  return { page };
};

export default loader;
